import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import logoutImg from '../../../assets/img/icons/spot-illustrations/45.png';
import { CiatAppContext } from '../../../providers';

function LogoutContent({ titleTag: TitleTag }) {
  const { logoutHandler } = useContext(CiatAppContext);

  if (logoutHandler) logoutHandler();
  useEffect(() => {
    window.localStorage.removeItem('logica_data');
  }, []);

  return (
    <>
      <img
        className="d-block mx-auto mb-4"
        src={logoutImg}
        alt="shield"
        width={100}
      />
      <TitleTag>Побачимось!</TitleTag>
      <p>
        Дякуємо за використання "Є-Пічник". Ви
        {' '}
        <br className="d-none d-sm-block" />
        успішно вийшли з системи.
      </p>
      <Button
        as={Link}
        color="primary"
        size="sm"
        className="mt-3"
        to="/"
      >
        <FontAwesomeIcon
          icon={faChevronLeft}
          transform="shrink-4 down-1"
          className="me-1"
        />
        Повернутись до авторизації
      </Button>
    </>
  );
}

LogoutContent.propTypes = {
  titleTag: PropTypes.string,
};

LogoutContent.defaultProps = {
  titleTag: 'h4',
};

export default LogoutContent;
